import styled from 'styled-components';
import LeftArrow from '../Icons/LeftArrow';

export const LeftArrowIcon = styled(LeftArrow)`
  flex: 1;
  position: absolute;
  align-self: center;
  margin-left: 12px;
  fill: ${(props: any) => props.theme.carvana.blue.primary};
`;

export const BreadcrumbContainer = styled.div`
  width: 100%;
  height: 54px;
  display: flex;
  background-color: ${(props: any) => props.theme.carvana.blue.dark};
  :hover {
    svg {
      fill: ${(props: any) => props.theme.carvana.blue.hover};
    }
    p {
      color: ${(props: any) => props.theme.carvana.blue.hover};
    }
  }
`;

export const NavigationLabel = styled.p`
  color: ${(props: any) => props.theme.carvana.blue.primary};
  font-weight: 700;
  font-size: 14px;
  letter-spacing: 0.3px;
  text-transform: uppercase;
  position: relative;
  align-self: center;
  text-align: center;
  flex: 3;
`;
